import { render, staticRenderFns } from "./UserTypes.vue?vue&type=template&id=f88394fa&scoped=true&"
import script from "./UserTypes.vue?vue&type=script&lang=js&"
export * from "./UserTypes.vue?vue&type=script&lang=js&"
import style0 from "./UserTypes.vue?vue&type=style&index=0&id=f88394fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88394fa",
  null
  
)

export default component.exports